import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Stats from "../components/Stats";
import Services from "../components/Services";
import Industries from "../components/Industries";
import CaseStudies from "../components/CaseStudies";
import Testimonials from "../components/Testimonials";
import WhyChoose from "../components/WhyChoose";
import TechStack from "../components/TechStack";
import Process from "../components/Process";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const Home = () => {
  useScrollReveal([]);
  return (
    <div className="bg-background">
      <Header />
      <main>
        <Hero />
        <Stats />
        <Services />
        <Industries />
        <CaseStudies />
        <Testimonials />
        <WhyChoose />
        <TechStack />
        <Process />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
